import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormButtonsConfig } from "@mipro/components";
import { Permissions } from "@main/permissions/permissions";
import { Router } from "@angular/router";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { PatientSettings, SettingsSectionsName, SystemConfigurationService } from "@main/system-configuration";
import { UserHelperService } from "@main/users/user-helper.service";
import { PlayerOfflineStorage } from "@project/player/player-offline.storage";
import { PatientLogin } from "@main/users";

@Component({
    selector: "check-patient-needsUpdating",
    template: `
        <div>
            <p-dialog
                [(visible)]="showWarning"
                [closable]="false"
                [style]="{ 'max-width': '600px', width: '100%' }"
                styleClass="warning-dialog"
                header="Warning"
                [modal]="true"
                [draggable]="false">
                <ng-template pTemplate="header">
                    <div class="p-dialog-title">
                        <span class="walkin-item-status-label">
                            <i class="pi pi-clock mr-1"></i>
                            REMINDER
                        </span>
                    </div>
                </ng-template>
                <p class="text-center mt-2">
                    Its been {{ monthsUntilReview }} Months since you last reviewed the
                    <naming-convention-label [type]="'EndUser'" [singular]="true"></naming-convention-label>
                    ({{ fullName }}). Do you want to review the
                    <naming-convention-label [type]="'EndUser'" [singular]="true"></naming-convention-label> record now?
                </p>
                <form-buttons doNotPropagateClick class="form-buttons" [config]="buttonsConfig">
                    <button pButton class="p-button-secondary mb-1" type="button" label="Skip" (click)="skip()" allowOffline>
                        <i class="material-icons">clear</i>
                    </button>
                </form-buttons>
            </p-dialog>
        </div>
    `,

    styles: [
        `
            :host ::ng-deep {
                .warning-dialog {
                    .p-dialog-header {
                        font-weight: bold;
                        color: rgb(240, 188, 109);
                        background-color: rgb(254, 252, 249);

                        .p-dialog-title {
                        }
                    }
                }
            }
        `
    ]
})
export class PatientReviewPromptComponent implements OnInit {
    showWarning = false;
    monthsUntilReview: number;
    loginId: string = null;
    fullName: string;
    offlinePatient: PatientLogin;

    @Input()
    patientId: string = null;

    @Input()
    returnUrl: string = null;

    @Input()
    episodeId: string = null;

    @Input()
    from: string = null;

    @Input()
    walkInDateString: string = null;

    @Input()
    walkInDate: Date = null;

    @Input()
    walkInId: string = null;

    @Input() createDateTime: Date = null;

    @Output() readonly back = new EventEmitter<boolean>();
    @Output() readonly redirectedToPatientDetails = new EventEmitter();

    buttonsConfig = <FormButtonsConfig>{
        saveLabel: "Review Now",
        saveFunc: () => {
            this.review();
        },
        justifyContent: "end"
    };

    shareFileFormButtonsConfig = <FormButtonsConfig>{
        saveLabel: "Send",
        cancelFunc: () => {
            this.back.emit(true);
        }
    };

    skip() {
        this.showWarning = false;
        this.back.emit(false);
    }

    review() {
        this.redirectedToPatientDetails?.emit();

        let queryParams = {
            profileId: this.patientId,
            returnUrl: this.returnUrl,
            from: this.from
        };

        if (this.walkInId) {
            queryParams["walkInId"] = this.walkInId;
        }

        if (this.walkInDateString) {
            queryParams["walkInDateString"] = this.walkInDateString;
        }

        if (this.walkInDate) {
            queryParams["walkInDate"] = this.walkInDate.toISOString();
        }

        if (this.episodeId) {
            queryParams["episodeId"] = this.episodeId;
        }

        if (this.createDateTime) {
            queryParams["createDateTime"] = this.createDateTime.toISOString();
        }
        queryParams["regNumberIsVisible"] = false;

        if (!!this.loginId) {
            this.router.navigate([`/app/patients/edit/${this.loginId}`], { queryParams });
        } else {
            this.router.navigate(["/app/patients/edit/0"], { queryParams });
        }
    }

    async ngOnInit() {
        if (this.patientId == null) {
            this.patientId = this.patientService.currentPatientId;
        }

        if (this.returnUrl == null) {
            this.returnUrl = this.router.url;
        }

        if (this.from == "note" || this.from == "walkIn") {
            var url = this.router.url.split("?");
            this.returnUrl = url[0];
        }

        if (this.from == "note") {
            this.from = this.walkInId ? "walk-ins" : "consultation-history";
        }
        this.offlinePatient = PlayerOfflineStorage.get(this.patientId);
        this.monthsUntilReview = this.systemConfigurationService.getSettingsSection<PatientSettings>(
            SettingsSectionsName.PatientSettings
        ).monthsUntilReview;
        if (this.offlinePatient?.id == this.patientId) {
            return;
        }

        let result = await this.patientService.checkIfPatientNeedsUpdating(this.patientId);

        if (!this.userHelperService.hasPermission(Permissions.WritePatient)) {
            this.back.emit(false);
            return;
        }

        this.loginId = result.loginId;
        this.fullName = result.fullName;

        if (result.isImportedAndNotReviwed) {
            this.review();
            return;
        }

        if (!result.isNeedsUpdating) {
            this.back.emit(false);
            return;
        }

        this.showWarning = true;
    }

    constructor(
        private router: Router,
        private patientService: PatientService,
        private systemConfigurationService: SystemConfigurationService,
        private userHelperService: UserHelperService
    ) {}
}
